module.exports = __webpack_public_path__ + "img/v3.3.73f3b796.png";